export default "__VITE_ASSET__DfWJntr7__"